import { render, staticRenderFns } from "./inform-list.vue?vue&type=template&id=ef60e57c&lang=pug&"
import script from "./inform-list.vue?vue&type=script&lang=js&"
export * from "./inform-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports